export class MultiEditModel {
  entityType: EntityType;
  entityId: string;
  action: EntityAction;
  changedBy: string;
  sessionId: string;
  entityName: string;
}

export enum EntityAction {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  OrderItems = 'OrderItems',
  UpdateProperties = 'UpdateProperties',
  AddNestedInspection = 'AddNestedInspection',
  DeleteNestedInspection = 'DeleteNestedInspection',
  Download = 'Download'
}

export enum EntityType {
  Inspection = 'Inspection',
  Point = 'Point',
  Section = 'Section',
  Plugin = 'Plugin',
  Folder = 'Folder'
}

export class InspectionSessionsModel {
  [sessionId: string]: InspectionSession;
}

export class InspectionSession {
  entityType: EntityType;
  entityId: string;
  user: string;
  date: Date;
  url: string;
  color: string;
  highlight: boolean;
  hidden: boolean;

  get away() {
    return this.hidden || new Date().getTime() - this.date.getTime() > 5 * 60 * 1000;
  }
}
